import React from 'react'
import Footer from '../components/Footer'

const RefundPolicy = () => {
  return (
    <div className=' w-full relative ' >
        <h2 className={` mb-4 text-2xl md:text-5xl tracking-tight mt-[100px] md:mt-[160px] font-bold text-center text-[#0e4d38]`}>Refund Policy As per UGC Guideline</h2>
        <div className=' w-10/12 mx-auto flex flex-col justify-between gap-[40px]' >
        <div className="flex flex-col mt-10 mb-5 ">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                    <div className="overflow-hidden">
                        <table className="min-w-full text-center text-sm font-light">
                        <thead
                            className="border-b bg-[#23376c] font-medium text-white rounded-md ">
                            <tr>
                            <th scope="col" className=" px-6 py-4">Category</th>
                            <th scope="col" className=" px-6 py-4">Percentage of Refund of fees</th>
                            <th scope="col" className=" px-6 py-4">Point of time when notice of withdrawal of admission is recieved in the HEI</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 ">1</td>
                            <td className="whitespace-nowrap  px-6 py-4">100%</td>
                            <td>15 days or more <strong>before</strong> the formally notified last date of admission</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >2</td>
                            <td className="whitespace-nowrap  px-6 py-4" >90%</td>
                            <td>Less than 15 days <strong>before</strong> the formally notified last date of admission</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >3</td>
                            <td className="whitespace-nowrap  px-6 py-4" >80%</td>
                            <td>15 days or less <strong>after</strong> the formally notified last date of admission</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >4</td>
                            <td className="whitespace-nowrap  px-6 py-4" >50%</td>
                            <td>30 days or less, but more than 15 days <strong>after the formally</strong> notified last date of admission</td>
                            </tr>
                            <tr className="border-b dark:border-neutral-500">
                            <td className="whitespace-nowrap  px-6 py-4 " >5</td>
                            <td className="whitespace-nowrap  px-6 py-4" >00%</td>
                            <td>More than 30 days <strong>after</strong> the formally notified last date of admission</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                    </div>
                </div>
                </div>
        </div>
        <Footer/>
    </div>
  )
}

export default RefundPolicy